document.addEventListener("DOMContentLoaded", function () {
  var isLoggedIn = window.isLoggedIn !== null;

  function updateMesVinsLink(linkElement) {
    var currentHref = linkElement.getAttribute("href");

    if (!isLoggedIn) {      
      var loginUrl = window.routes.storefront_login_url;
      var returnUrl = '/pages/wine-profile-selector'; 
      if (loginUrl.includes('?')) {
        loginUrl += "&return_to=" + encodeURIComponent(returnUrl);
      } else {
        loginUrl += "?return_to=" + encodeURIComponent(returnUrl);
      }
      linkElement.setAttribute("href", loginUrl);
      
    } else {
      
      const currentCustomerTagsElement = document.getElementById("krf-customer-tags");

      if (currentCustomerTagsElement) {
        const currentCustomerTags = currentCustomerTagsElement.value.trim();

        if (currentCustomerTags) {
          const pageRouteCustomerTagMap = {
            'le pépin voyageur': 'le-pepin-voyageur',
            'le raisin vif': 'le-raisin-vif',
            'le cep tranquille': 'le-cep-tranquille',
            'la vrille curieuse': 'la-vrille-curieuse',
            'la grappe joyeuse': 'la-grappe-joyeuse',
          };

          const customerTagKeys = Object.keys(pageRouteCustomerTagMap).map(tag => tag.toLowerCase());
          const customerTagsArray = currentCustomerTags.split(',').map(tag => tag.trim().toLowerCase());
          const customerTag = customerTagsArray.find(tag => customerTagKeys.includes(tag));

          const hasLessThan40Tag = customerTagsArray.some(tag => !isNaN(tag) && Number(tag) < 35);

          if (customerTag) {
            const wineProfilePath = pageRouteCustomerTagMap[Object.keys(pageRouteCustomerTagMap).find(key => key.toLowerCase() === customerTag)];
            const finalPath = hasLessThan40Tag
              ? `/pages/${wineProfilePath}-v1`
              : `/pages/${wineProfilePath}-v2`;
            linkElement.setAttribute("href", finalPath); 
          } else {
            
            linkElement.setAttribute("href", "/pages/quiz");
          }
        } else {
          
          linkElement.setAttribute("href", "/pages/quiz");
        }
      }
    }
  }

  var menuItem = document.querySelector(".menu__item a.navlink");
  if (menuItem) {
    updateMesVinsLink(menuItem);
  }

  var mobileMenuItem = document.querySelector(".sliderow__title");
  if (mobileMenuItem) {
    updateMesVinsLink(mobileMenuItem);
  }
});
